import React, {useEffect, useRef, useState} from 'react';
import SignaturePad from "signature_pad";
import './Signature.css';
import {actReducer, downloadViolationFile, getActs, getSelectedAct, setSelectedSignatureThunk} from "../../../../redux/reducers/act-reducer";
import {useDispatch, useSelector} from "react-redux";
import { getProfile } from "../../../../redux/reducers/user-profile-reducer";
import { MasterOfActsAPI } from "../../../../api/api";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Dialog } from '../../../Dialog/Dialog';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import {makeStyles} from "@material-ui/core";
import { UserRoles } from '../../../../utils/roles';


export const useStyles = makeStyles(() => ({
    greenButton: {
        color: '#0A8100',
        border: '1px solid #0A8100'
    },
}))

const Signature = ({getFieldProps, ...props}) => {

    const classes = useStyles()
   
    const {selectedAct} = useSelector(getActs)
    const { user } = useSelector(getProfile);
    const name = props.name
    const label = props.label
    const isNew = useSelector(state => state.actReducer.selectedAct)

    const optionField = props.content.required

   

    let canvas = useRef();
    let savePNGButton = useRef();
    let clearButton = useRef();

    const [open, setOpen] = useState(false)
    const [ref, setRef] = useState(false)


    useEffect(() => {
    if (  open === true) {
        canvas = canvas.current
        savePNGButton = savePNGButton.current
        clearButton = clearButton.current

        const signaturePad = new SignaturePad(canvas);
        signaturePad.backgroundColor = 'transparent'
        signaturePad.penColor = "rgb(60, 100, 244)";

     

        function resizeCanvas() {
            const ratio =  Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);

            signaturePad.fromData(signaturePad.toData());
        
           
        }

        window.onresize = resizeCanvas;
        resizeCanvas();

        function dataURLToBlob(dataURL) {
          const parts = dataURL.split(';base64,');
          const contentType = parts[0].split(":")[1];
          const raw = window.atob(parts[1]);
          const rawLength = raw.length;
          const uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
          }
          return new Blob([uInt8Array], { type: contentType });
        }

        savePNGButton.addEventListener("click", async () => {
            if (signaturePad.isEmpty()) {
                alert("Please provide a signature first.");
            } else {
                
                const dataURL = signaturePad.toDataURL("image/png");
               

                let imageBlob = dataURLToBlob(dataURL);
                
                const response = await MasterOfActsAPI.uploadSignature(imageBlob, selectedAct?.creator || user.id);
                
                if (response.status === 201) {
                 
                    props.setFieldValue([name], response.data.id)
                }  
            }
        });

        clearButton.addEventListener("click", () => {
            signaturePad.clear();
        });
    }
    }, [isNew, ref]);

    const handleOpen = () => {
        setOpen(!open)
    }

    const handleRef = () => {
        setRef(!ref)
    }

    
    if (user.role === UserRoles.FIELD_CONTRACTOR && optionField) return <React.Fragment></React.Fragment>
        else return (
     
            <React.Fragment>
                {(selectedAct?.raw_content[name] === "" || selectedAct === null) && getFieldProps.value === "" ?
                <React.Fragment>  
                    <div style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <Button color="secondary" variant="contained" onClick={handleOpen}> {label}</Button>
                        {optionField &&
                            <Typography variant='h6' style={{color: 'red', marginLeft: '20px'}}>Обязательное поле !</Typography>
                        }
                    </div>
                    <Dialog
                        open={open}
                        title={'Форма подписи'}
                        handleClose={() => {handleOpen(); handleRef();}}
                        fullWidth
                        maxWidth={'sm'}
                        actions={<Button 
                            ref={savePNGButton} 
                            type="button"  
                            data-action="save-png"
                            variant="outlined"
                            classes={{outlined: classes.greenButton}}
                            onClick={() => {handleOpen(); handleRef();}}
                        >
                            Подписать 
                        </Button>}
                    >   
                        {ref === false &&
                        <Button variant="contained" color="primary" onClick={handleRef}>Создать подпись</Button>
                        }
                            {ref &&
                                <div className="sign">
                                    <canvas ref={canvas}> </canvas>    
                                    <div className="controls">
                                        <Button 
                                            variant="contained"
                                            color="primary"
                                            ref={clearButton} 
                                            type="button" 
                                            className="button clear" 
                                            data-action="clear"                    
                                        >
                                            Очистить 
                                        </Button>
                                    </div>
                                </div>
                            }
                    </Dialog>
                </React.Fragment> 
                :  
                <Typography className='marg' variant='h6'>{label} подписал документ <HowToRegIcon fontSize='large' style={{color: '#006400'}} /> </Typography>
                } 
            </React.Fragment>
    );
};

export default Signature;